import { useEffect } from 'react';

import { useAuth } from '@/auth/AuthContext';

function Redirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
}

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isSignedIn, isAdmin, isLoading, signOut } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mb-3 inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-t-transparent text-green-600" />
          <p className="text-sm text-slate-500">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Redirect to="/login" />;
  }

  if (!isAdmin) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="card max-w-sm text-center">
          <div className="mb-4 text-4xl">🚫</div>
          <h2 className="mb-2 text-lg font-semibold text-slate-900">Accès refusé</h2>
          <p className="text-sm text-slate-500">
            Vous n&apos;avez pas les droits d&apos;accès au back-office admin.
          </p>
          <button
            type="button"
            onClick={() => void signOut()}
            className="mt-4 h-10 w-full rounded-lg bg-slate-900 text-sm font-semibold text-white shadow-sm hover:bg-slate-800"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
